import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-ocean-800 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-ocean-700 text-ocean-300">
          <i className="ri-compass-discover-line text-4xl" />
        </div>
        <h1 className="font-serif text-6xl md:text-8xl font-bold text-ocean-400 mb-4">
          404
        </h1>
        <p className="text-white/80 text-lg md:text-xl mb-2">
          お探しのページが見つかりません
        </p>
        <p className="text-white/50 text-sm mb-8">
          ページが移動または削除された可能性があります
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-ocean-500 hover:bg-ocean-400 text-white font-medium rounded-full transition-all whitespace-nowrap"
        >
          <i className="ri-home-line" />
          トップページへ戻る
        </Link>
      </div>
    </div>
  );
}
